import React from 'react';
import { Route } from 'react-router-dom';

import FaqFicha from '../../Fornecedores/FAQ/FaqFicha';
import FaqIndex from '../../Fornecedores/FAQ/FaqIndex';
import FornecedoresComunicacoesIndex from '../../Fornecedores/Fornecedores/FornecedoresComunicacoesIndex';
import FornecedoresFicha from '../../Fornecedores/Fornecedores/FornecedoresFicha';
import FornecedoresIndex from '../../Fornecedores/Fornecedores/FornecedoresIndex';
import FornecedoresPRIndex from '../../Fornecedores/Fornecedores/FornecedoresPR';
import FornecedoresRepresentantesIndex from '../../Fornecedores/Fornecedores/FornecedoresRepresentantesIndex';
import HistoricoRT from '../../Fornecedores/Fornecedores/HistoricoRT';

const FornecedoresRoutes = () => {
  return (
    <>
      <Route path="fornecedores/fornecedores" element={<FornecedoresIndex />} />
      <Route
        path="fornecedores/fornecedores/dadosgerais"
        element={<FornecedoresFicha />}
      />
      <Route
        path="fornecedores/fornecedores/:id/dadosgerais"
        element={<FornecedoresFicha />}
      />
      <Route
        path="fornecedores/fornecedores/:id/representantes"
        element={<FornecedoresRepresentantesIndex />}
      />
      <Route
        path="fornecedores/fornecedores/:id/pr"
        element={<FornecedoresPRIndex />}
      />
      <Route
        path="fornecedores/fornecedores/:id/historicort"
        element={<HistoricoRT />}
      />
      <Route
        path="fornecedores/fornecedores/:id/comunicacoes"
        element={<FornecedoresComunicacoesIndex />}
      />

      <Route path="fornecedores/faq" element={<FaqIndex />} />
      <Route path="fornecedores/faq/dadosgerais" element={<FaqFicha />} />
      <Route path="fornecedores/faq/:id/dadosgerais" element={<FaqFicha />} />
    </>
  );
};

export default FornecedoresRoutes;
